import React from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { table_tabs, div_title, div_title_permission, first, last } from "../../maintainers.module.scss";

const permissions_categories = [
	{
		name: "Compras",
		screens: [18, 19, 20, 21],
		tools: [1, 2, 3, 4],
	},
	{
		name: "Planificación",
		screens: [1, 54, 55, 56, 57, 61, 64, 68],
		tools: [15, 26],
	},
	{
		name: "Inventario",
		screens: [2, 23, 58, 62, 67],
		tools: [5, 6],
	},
	{
		name: "Historiales",
		screens: [24, 25, 26, 27, 32],
		tools: [7, 8, 9, 10, 11],
	},
	{
		name: "Configuración",
		screens: [9, 36, 37, 38, 41, 43, 44, 45, 46, 47, 48, 51, 65, 66],
		tools: [20],
	},
	{
		name: "Mantenedores",
		screens: [30],
		tools: [12],
	},
];

const UsersPermissions = ({ data, setData }) => {
	const { user } = useSelector((state) => state.auth);
	const tools = user ? user.tools : [];

	const handleChangeSelected = (e, i, j) => {
		let newUserPermissions = [...data.permissions];

		newUserPermissions[i]["details"][j]["value"] = e.target.checked;

		setData({ ...data, permissions: newUserPermissions });
	};

	return (
		<table className={table_tabs} border="0" cellSpacing="0" cellPadding="0">
			<thead>
				<tr>
					<th style={{ width: "40%" }}>
						<div className={`${div_title} ${first}`}>Aplicación</div>
					</th>
					<th style={{ width: "12%" }}>
						<div className={`${div_title}`}>Crear</div>
					</th>
					<th style={{ width: "12%" }}>
						<div className={`${div_title}`}>Editar</div>
					</th>
					<th style={{ width: "12%" }}>
						<div className={`${div_title}`}>Ver</div>
					</th>
					<th style={{ width: "12%" }}>
						<div className={`${div_title}`}>Eliminar</div>
					</th>
					<th style={{ width: "12%" }}>
						<div className={`${div_title} ${last}`} style={{ justifyContent: "center" }}>
							Aprobar
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				{permissions_categories.map((pc, k) => {
					let showElement = false;
					if (pc.name === "Configuración") {
						showElement = true;
					} else {
						pc.tools.forEach((element) => {
							const exist = tools.find((t) => Number(t.id) === Number(element));
							if (exist) {
								showElement = true;
							}
						});
					}

					if (!showElement) {
						return null;
					}

					return (
						<React.Fragment key={k}>
							<tr>
								<td colSpan={6}>
									<div className={div_title_permission}> {pc.name}</div>
								</td>
							</tr>
							{data.permissions &&
								data.permissions.map((userPermission, i) => {
									if (!pc.screens.includes(userPermission.screen_id)) {
										return <tr key={i}></tr>;
									}

									// TODO: esto se puede optimizar
									// Compra
									if (userPermission.screen_id === 18 && !tools.find((tool) => tool.id === 1)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 19 && !tools.find((tool) => tool.id === 2)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 20 && !tools.find((tool) => tool.id === 3)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 61 && !tools.find((tool) => tool.id === 3)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 21 && !tools.find((tool) => tool.id === 4)) {
										return <tr key={i}></tr>;
									}
									// Planificacion
									if (userPermission.screen_id === 54 && !tools.find((tool) => tool.id === 15)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 55 && !tools.find((tool) => tool.id === 15)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 56 && !tools.find((tool) => tool.id === 15)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 57 && !tools.find((tool) => tool.id === 15)) {
										return <tr key={i}></tr>;
									}
									// Inventario
									if (userPermission.screen_id === 2 && !tools.find((tool) => tool.id === 5)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 23 && !tools.find((tool) => tool.id === 6)) {
										return <tr key={i}></tr>;
									}
									// Historiales
									if (userPermission.screen_id === 24 && !tools.find((tool) => tool.id === 7)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 25 && !tools.find((tool) => tool.id === 8)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 26 && !tools.find((tool) => tool.id === 9)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 27 && !tools.find((tool) => tool.id === 10)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 32 && !tools.find((tool) => tool.id === 11)) {
										return <tr key={i}></tr>;
									}
									// Configuración
									if (userPermission.screen_id === 9 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 36 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 37 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 38 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 41 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 43 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 44 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 45 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 46 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 47 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 48 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}
									if (userPermission.screen_id === 51 && !tools.find((tool) => tool.id === 20)) {
										return <tr key={i}></tr>;
									}

									// Mantenedores
									if (userPermission.screen_id === 30 && !tools.find((tool) => tool.id === 12)) {
										return <tr key={i}></tr>;
									}

									return (
										<tr key={i}>
											<td style={{ fontSize: "13px", paddingLeft: "1.5em" }}>{userPermission.screen}</td>
											{userPermission.details &&
												userPermission.details.map((detail, j) => {
													if (detail.permission_id === 5 && !userPermission.need_approval) {
														return null;
													}

													return (
														<td key={j} style={{ textAlign: "center" }}>
															<Form.Check
																type="switch"
																id={`switch${i}${j}`}
																checked={detail.value}
																onChange={(e) => handleChangeSelected(e, i, j)}
															/>
														</td>
													);
												})}
										</tr>
									);
								})}
						</React.Fragment>
					);
				})}
			</tbody>
		</table>
	);
};

export default UsersPermissions;
